import { AlertOutlined, BellOutlined, ExportOutlined, FileDoneOutlined, FileSyncOutlined, FormOutlined, YoutubeOutlined } from "@ant-design/icons";
import { Avatar, Badge, Button, List, Popover, Tooltip } from "antd";
import { MENU } from "constants/accesos";
import useGetLinks from "hooks/useGetLinks";
import useStyles from "hooks/useStyles";
import { useNavigate } from "react-router-dom";
import useNotificacionesSocket from "./useNotificacionesSocket";

const Notificaciones = ({ usuario, buttonStyles, accesoVisible }) => {
  const navigate = useNavigate();
  const { links } = useGetLinks();
  const { totales, contextHolder } = useNotificacionesSocket(usuario);
  const { algorithm } = useStyles();
  const className = algorithm === 'dark' ? "dark-list-notificaciones" : "light-list-notificaciones";
  const iconStyle = { fontSize: 20, color: 'gray' };

  const totalNotificaciones = [
    {
      key: MENU.FILIALES.AUTORIZACIONES,
      value: totales?.total_autorizaciones ?? 0,
    },
    {
      key: MENU.CLIENTES.ACUERDOS,
      value: totales?.total_acuerdos ?? 0,
    },
    {
      key: MENU.SISTEMA.SOLICITUDES,
      value: totales?.total_solicitudes ?? 0,
    },
  ].reduce((acc, { key, value }) => {
    return accesoVisible(key) ? acc + value : acc;
  }, 0);

  const items = [
    {
      key: "autorizaciones",
      icon: <FileDoneOutlined style={iconStyle} />,
      label: "Autorizaciones",
      description: "Ver y gestionar autorizaciones",
      count: totales?.total_autorizaciones,
      hidden: !accesoVisible(MENU.FILIALES.AUTORIZACIONES),
      onClick: () => navigate("/autorizaciones"),
    },
    {
      key: "acuerdos",
      icon: <FileSyncOutlined style={iconStyle} />,
      label: "Acuerdos",
      description: "Acuerdos vencidos a renovar",
      count: totales?.total_acuerdos,
      hidden: !accesoVisible(MENU.CLIENTES.ACUERDOS),
      onClick: () => navigate("/acuerdos", { state: { verVencidos: true, }}),
    },
    {
      key: "solicitudes",
      icon: <FormOutlined style={iconStyle} />,
      label: "Solicitudes",
      description: "Ver y gestionar solicitudes",
      count: totales?.total_solicitudes,
      hidden: !accesoVisible(MENU.SISTEMA.SOLICITUDES),
      onClick: () => navigate("/solicitudes"),
    },
    {
      key: "iniciar-solicitud",
      icon: <AlertOutlined style={iconStyle} />,
      label: "Iniciar una solicitud",
      description: "Crear una nueva solicitud",
      hidden: !accesoVisible(MENU.SISTEMA.SOLICITUDES),
      onClick: () => navigate("/solicitudes/nuevo"),
    },
    {
      key: "tutorial",
      icon: <YoutubeOutlined style={iconStyle} />,
      label: "Tutorial",
      extra: <ExportOutlined style={{ color: 'gray' }} />,
      onClick: () => window.open(links[0].url, "_blank"),
    },
  ].filter(i => !i.hidden);

  const content = (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={items}
      className={className}
      renderItem={(item) => (
        <List.Item
          key={item.key}
          style={{ cursor: "pointer", alignSelf: 'center' }}
          onClick={() => item.onClick()}
          extra={item.extra ? item.extra : (
            <Badge
              showZero={false}
              count={item.count ?? 0}
            />
          )}
        >
          <List.Item.Meta
            className="meta-title-without-margin"
            style={{ alignItems: 'center' }}
            avatar={<Avatar icon={item.icon} style={{ backgroundColor: "transparent" }} />}
            title={item.label}
            description={item.description}
          />
        </List.Item>
      )}
    />
  );

  return (
    <Popover
      placement="bottom"
      trigger="click"
      content={content}
      styles={{
        root: { width: 305 },
        body: { padding: 0 }
      }}
    >
      {contextHolder}
      <Tooltip title="Notificaciones" mouseLeaveDelay={0}>
        <Button
          type="text"
          size="small"
          style={buttonStyles}
          icon={
            <Badge
              count={
                accesoVisible([
                  MENU.CASA_CENTRAL.ACUERDOS,
                  MENU.CLIENTES.ACUERDOS,
                  MENU.FILIALES.AUTORIZACIONES,
                  MENU.SISTEMA.SOLICITUDES
                ]) ? totalNotificaciones : 0
              }
              showZero={false}
              size="small"
              offset={[5, -2]}
              style={{ boxShadow: "none", padding: '0 4px' }}
            >
              <BellOutlined style={{ color: buttonStyles?.color }} />
            </Badge>
          }
        />
      </Tooltip>
    </Popover>
  );
};

export default Notificaciones;